import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PaginationControlsProps {
  page: number;
  totalPages: number;
  total: number;
  pageSize: number;
  onPrev: () => void;
  onNext: () => void;
  hasPrev: boolean;
  hasNext: boolean;
}

export function PaginationControls({ page, totalPages, total, pageSize, onPrev, onNext, hasPrev, hasNext }: PaginationControlsProps) {
  if (total <= pageSize) return null;

  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  return (
    <div className="flex items-center justify-between mt-4 px-1">
      <p className="text-xs text-muted-foreground">
        {from}–{to} / {total}
      </p>
      <div className="flex items-center gap-1">
        <Button variant="outline" size="icon" className="h-8 w-8" disabled={!hasPrev} onClick={onPrev}>
          <ChevronLeft size={14} />
        </Button>
        <span className="text-xs text-muted-foreground px-2">{page} / {totalPages}</span>
        <Button variant="outline" size="icon" className="h-8 w-8" disabled={!hasNext} onClick={onNext}>
          <ChevronRight size={14} />
        </Button>
      </div>
    </div>
  );
}
